import style from "../../style.module.scss";
import { Button } from "antd";
import React from "react";
import { ExamPaperItem } from "../../../../../service/exam";
import { ExamExportModal } from "./Components/ExamExportModal";
import useModalHandler from "../../../../../utils/v3/useModalHandler";

interface DownloadBtnProps {
    name: string;
    data: ExamPaperItem[];
}

export function DownloadBtn({ name, data }: DownloadBtnProps) {
    const modal = useModalHandler();

    return (
        <>
            <Button type="primary" className={style.btn} onClick={modal.open}>
                打包全部试卷
            </Button>

            {modal.render(<ExamExportModal name={name} data={data} />)}
        </>
    );
}
